import { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Dropdown, Form, Row, Table } from 'react-bootstrap';
import { Link, useAsyncError, useNavigate, useParams } from 'react-router-dom';
import Authenticator from '../authenticator';
import Loading from '../components/loading';
import SuccessMessage from '../components/successMessage';
import ErrorMessage from '../components/errorMessage';
import Select from 'react-select';
import api from '../api/api';

export default function ConcretDosageForm() {

  const navigate = useNavigate();
  const { concreteDosageId } = useParams();

  const [isLoading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [concreteDosageErrors, setConcreteDosageErrors] = useState([]);
  const [packagingErrorMessage, setPackagingErrorMessage] = useState('');
  const [showConcreteDosageResult, setShowConcreteDosageResult] = useState(false);

  const [showReceiptConcreteModal, setShowReceiptConcreteModal] = useState(false);

  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [mortarPercentage, setMortarPercentage] = useState('');
  const [incorporatedAir, setIncorporatedAir] = useState('');

  // New state variables for additional fields
  const [resistance, setResistance] = useState('');
  const [resistanceStandardDeviation, setResistanceStandardDeviation] = useState('');
  const [slump, setSlump] = useState('');
  const [waterReducingAdditive, setWaterReducingAdditive] = useState('');
  const [waterReducingAdditivePercentage, setWaterReducingAdditivePercentage] = useState('');
  const [otherAdditives, setOtherAdditives] = useState('');
  const [otherAdditivesPercentage, setOtherAdditivesPercentage] = useState('');
  const [concreteVolume, setConcreteVolume] = useState('');

  const [averageDiameter, setAverageDiameter] = useState('');
  const [maxDiameter, setMaxDiameter] = useState('');

  const [finenessModulus, setFinenessModulus] = useState('');

  const [comboBoxOptionsToSands, setcomboBoxOptionsToSands] = useState([]);
  const [comboBoxOptionsToGravels, setcomboBoxOptionsToGravels] = useState([]);
  const [comboBoxOptionsToDosageStudies, setcomboBoxOptionsToDosageStudies] = useState([]);
  const [comboBoxOptionsToWaters, setcomboBoxOptionsToWaters] = useState([]);
  const [comboBoxOptionsToCements, setcomboBoxOptionsToCements] = useState([]);
  const [comboBoxOptionsToWaterReducingAdditives, setcomboBoxOptionsToWaterReducingAdditives] = useState([]);
  const [comboBoxOptionsToAdditives, setcomboBoxOptionsToAdditives] = useState([]);

  // Material selection state variables
  const [cement, setCement] = useState('');
  const [water, setWater] = useState('');

  const [selectedGravel, setSelectedGravel] = useState('');
  const [percentageFromGravel, setPercentageFromGravel] = useState('');
  const [humidityFromGravel, setHumidityFromGravel] = useState('');
  const [gravelsAndPercentages, setGravelsAndPercentages] = useState([]);

  const [selectedSand, setSelectedSand] = useState('');
  const [percentageFromSand, setPercentageFromSand] = useState('');
  const [humidityFromSand, setHumidityFromSand] = useState('');
  const [sandsAndPercentages, setSandsAndPercentages] = useState([]);

  // Additive arrays
  const [additiveConsumptionPercentage, setAdditiveConsumptionPercentage] = useState('');

  const [waterReducingAdditivesAndPercentages, setWaterReducingAdditivesAndPercentages] = useState([]);
  const [otherAdditivesAndPercentages, setOtherAdditivesAndPercentages] = useState([]);

  const [dosageStudyOne, setDosageStudyOne] = useState('');
  const [dosageStudyTwo, setDosageStudyTwo] = useState('');

  function sanitizeNumericInput(value) {
    return value.replace(/[^0-9.,]/g, '');
  }

  useEffect(() => {
    if (concreteDosageId) {
      loadConcreteDosage(concreteDosageId);
    }
    getMaterials();
    getDosageStudies();
  }, []);

  function loadConcreteDosage(concreteDosageId) {
    api.get(`/concrete-dosage/${concreteDosageId}`, {
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    })
      .then((returnFromApi) => {
        const concreteDosage = returnFromApi.data;
        console.log(concreteDosage);
        setName(concreteDosage.name);
        setCode(concreteDosage.code);
        setMortarPercentage(concreteDosage.mortarPercentage);
        setIncorporatedAir(concreteDosage.incorporatedAirPercentage);
        setResistance(concreteDosage.concreteResistance);
        setResistanceStandardDeviation(concreteDosage.resistanceStandardDeviation);
        setSlump(concreteDosage.slump);
        const cementToSelectBox = {
          value: concreteDosage.cementId,
          label: concreteDosage.cementLabel
        };
        setCement(cementToSelectBox);
        const waterToSelectBox = {
          value: concreteDosage.waterId,
          label: concreteDosage.waterLabel
        };
        setWater(waterToSelectBox);
        const waterReducingAdditiveToSelectBox = {
          value: concreteDosage.waterReducingAdditiveId,
          label: concreteDosage.waterReducingAdditiveLabel
        };
        setWaterReducingAdditive(waterReducingAdditiveToSelectBox);
        setAdditiveConsumptionPercentage(concreteDosage.additiveConsumptionPercentage);
        const dosageStudyOneToSelectBox = {
          value: concreteDosage.dosageStudyIdOne,
          label: concreteDosage.dosageStudyOneLabel
        };
        setDosageStudyOne(dosageStudyOneToSelectBox);
        const dosageStudyTwoToSelectBox = {
          value: concreteDosage.dosageStudyIdTwo,
          label: concreteDosage.dosageStudyTwoLabel
        };
        setDosageStudyTwo(dosageStudyTwoToSelectBox);
        const gravelsAndPercentagesToList = concreteDosage.gravelsAndPercentages.map((gravel) => ({
          gravelToAdd: {
            value: gravel.gravelId,
            label: gravel.name
          },
          percentageFromGravelToAdd: gravel.percentage,
          humidityFromGravelToAdd: gravel.humidity
        }));
        setGravelsAndPercentages(gravelsAndPercentagesToList);
        const sandsAndPercentagesToList = concreteDosage.sandsAndPercentages.map((sand) => ({
          sandToAdd: {
            value: sand.sandId,
            label: sand.name
          },
          percentageFromSandToAdd: sand.percentage,
          humidityFromSandToAdd: sand.humidity
        }));
        setAverageDiameter(concreteDosage.averageDiameter);
        setMaxDiameter(concreteDosage.maxDiameter);
        setSandsAndPercentages(sandsAndPercentagesToList);
        setFinenessModulus(concreteDosage.finenessModulus);
        setConcreteVolume(concreteDosage.concreteVolume);
        setConcreteDosageErrors(concreteDosage.errors);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });

  }

  function getMaterials() {
    getGravels();
    getSands();
    getAllWatersToComboBox();
    getAllCementsToComboBox();
    getAllWaterReducingAdditivesToComboBox();
    getAllAdditivesToComboBox();
  }

  function getGravels() {
    setLoading(true);
    api
      .get('/materials/gravels/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToGravels(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getSands() {
    setLoading(true);
    api
      .get('/materials/sands/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToSands(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getAllWatersToComboBox() {
    setLoading(true);
    api
      .get('/materials/waters/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToWaters(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getAllCementsToComboBox() {
    setLoading(true);
    api
      .get('/materials/cements/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToCements(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getAllWaterReducingAdditivesToComboBox() {
    setLoading(true);
    api
      .get('/materials/water-reducing-additives/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToWaterReducingAdditives(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getAllAdditivesToComboBox() {
    setLoading(true);
    api
      .get('/materials/others-additives/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((material) => ({
          value: material.materialId,
          label: material.name
        }));
        setcomboBoxOptionsToAdditives(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function getDosageStudies() {
    setLoading(true);
    api
      .get('/dosage-study/combobox', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        const options = returnFromApi.data.map((dosageStudy) => ({
          value: dosageStudy.id,
          label: dosageStudy.name
        }));
        setcomboBoxOptionsToDosageStudies(options);

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function closeReceiptConcreteModal() {
    setShowReceiptConcreteModal(false);
  }

  function addGravel() {
    const gravel = {
      gravelToAdd: selectedGravel,
      percentageFromGravelToAdd: percentageFromGravel,
      humidityFromGravelToAdd: humidityFromGravel
    };

    gravelsAndPercentages.push(gravel);

    calculateAverageDiameter();
    calculateMaximumDiameter();

    setSelectedGravel('');
    setPercentageFromGravel('');
    setHumidityFromGravel('');
  }

  function deleteGravelFromList(gravel) {
    const gravelIndex = gravelsAndPercentages.indexOf(gravel);

    if (gravelIndex > -1) {
      gravelsAndPercentages.splice(gravelIndex, 1);
    }

    calculateAverageDiameter();
    calculateMaximumDiameter();
  }

  function addSand() {
    const sand = {
      sandToAdd: selectedSand,
      percentageFromSandToAdd: percentageFromSand,
      humidityFromSandToAdd: humidityFromSand
    };
    sandsAndPercentages.push(sand);

    calculateFinenessModulus();

    setSelectedSand('');
    setPercentageFromSand('');
    setHumidityFromSand('');
  }

  function deleteSandFromList(sand) {
    const sandIndex = sandsAndPercentages.indexOf(sand);

    if (sandIndex > -1) {
      sandsAndPercentages.splice(sandIndex, 1);
    }

    calculateFinenessModulus();
  }

  function calculateMaximumDiameter() {
    setLoading(true);
    const input = gravelsAndPercentages.map((item) => ({
      percentageOfUsage: item.percentageFromGravelToAdd,
      materialId: item.gravelToAdd.value
    }));

    api
      .post('/dosage-study/maximum-diameter/calculate', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setMaxDiameter(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro: ' + err);
      });
  }

  function calculateAverageDiameter() {
    setLoading(true);
    const input = gravelsAndPercentages.map((item) => ({
      percentageOfUsage: item.percentageFromGravelToAdd,
      materialId: item.gravelToAdd.value
    }));

    api
      .post('/dosage-study/average-diameter/calculate', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setAverageDiameter(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro: ' + err);
      });
  }

  function calculateFinenessModulus() {
    setLoading(true);
    const input = sandsAndPercentages.map((item) => ({
      percentageOfUsage: item.percentageFromSandToAdd,
      materialId: item.sandToAdd.value
    }));

    api
      .post('/dosage-study/fineness-modulus/calculate', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setFinenessModulus(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro: ' + err);
      });
  }

  function addWaterReducingAdditive() {
    if (!waterReducingAdditive || !waterReducingAdditivePercentage) {
      setShowErrorMessage(true);
      setErrorMessage('Por favor, selecione um aditivo e informe a porcentagem.');
      return;
    }

    const additive = {
      additiveToAdd: waterReducingAdditive,
      percentageFromAdditiveToAdd: waterReducingAdditivePercentage
    };

    waterReducingAdditivesAndPercentages.push(additive);

    setWaterReducingAdditive('');
    setWaterReducingAdditivePercentage('');
  }

  function deleteWaterReducingAdditiveFromList(additive) {
    const additiveIndex = waterReducingAdditivesAndPercentages.indexOf(additive);

    if (additiveIndex > -1) {
      waterReducingAdditivesAndPercentages.splice(additiveIndex, 1);
    }
  }

  function addOtherAdditive() {
    if (!otherAdditives || !otherAdditivesPercentage) {
      setShowErrorMessage(true);
      setErrorMessage('Por favor, selecione um aditivo e informe a porcentagem.');
      return;
    }

    const additive = {
      additiveToAdd: otherAdditives,
      percentageFromAdditiveToAdd: otherAdditivesPercentage
    };

    otherAdditivesAndPercentages.push(additive);

    setOtherAdditives('');
    setOtherAdditivesPercentage('');
  }

  function deleteOtherAdditiveFromList(additive) {
    const additiveIndex = otherAdditivesAndPercentages.indexOf(additive);

    if (additiveIndex > -1) {
      otherAdditivesAndPercentages.splice(additiveIndex, 1);
    }
  }

  const saveConcreteDosage = (event) => {
    event.preventDefault();
    setLoading(true);

    const input = {
      id: concreteDosageId,
      name: name,
      code: code,
      mortarPercentage: mortarPercentage,
      percentageOfincorporatedAir: incorporatedAir,
      resistance: resistance,
      standardDeviationOfResistance: resistanceStandardDeviation,
      slump: slump,
      waterReducingAdditiveId: waterReducingAdditive?.value || '',
      waterReducingAdditivePercentage: waterReducingAdditivePercentage,
      otherAdditives: otherAdditives,
      otherAdditivesPercentage: otherAdditivesPercentage,
      concreteVolume: concreteVolume,
      cementId: cement?.value || '',
      waterId: water?.value || '',
      gravelsAndPercentages: gravelsAndPercentages.map((item) => ({
        gravelId: item.gravelToAdd.value,
        percentage: item.percentageFromGravelToAdd,
        humidityPercentage: item.humidityFromGravelToAdd
      })),
      averageDiameterOfGravels: averageDiameter,
      maximumDiameterOfGravels: maxDiameter,
      sandsAndPercentages: sandsAndPercentages.map((item) => ({
        sandId: item.sandToAdd.value,
        percentage: item.percentageFromSandToAdd,
        humidityPercentage: item.humidityFromSandToAdd
      })),
      finenessModulusOfSands: finenessModulus,
      additiveConsumptionPercentage: additiveConsumptionPercentage,
      waterReducingAdditivesAndPercentages: waterReducingAdditivesAndPercentages.map((item) => ({
        additiveId: item.additiveToAdd.value,
        percentage: item.percentageFromAdditiveToAdd
      })),
      otherAdditivesAndPercentages: otherAdditivesAndPercentages.map((item) => ({
        additiveId: item.additiveToAdd.value,
        percentage: item.percentageFromAdditiveToAdd
      })),
      dosageStudyIdOne: dosageStudyOne?.value || '',
      dosageStudyIdTwo: dosageStudyTwo?.value || ''
    };

    if (concreteDosageId) {
      api.put('/concrete-dosage', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      }).then((returnFromApi) => {
        setLoading(false);
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
      }).catch((returnFromApi) => {
        console.error(returnFromApi.response.data);
        setShowErrorMessage(true);
        setErrorMessage(returnFromApi.response.data);
        setLoading(false);
      });
    } else {
      api.post('/concrete-dosage', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      }).then((returnFromApi) => {
        setLoading(false);
        setShowSuccessMessage(true);
        setSuccessMessage(returnFromApi.data);
      }).catch((error) => {
        console.error(error.response.data);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
    }
  };

  const calculateReceipt = (event) => {
    setLoading(true);
    const input = {
      name: name,
      code: code,
      mortarPercentage: mortarPercentage,
      percentageOfincorporatedAir: incorporatedAir,
      // New fields added
      resistance: resistance,
      resistanceStandardDeviation: resistanceStandardDeviation,
      slump: slump,
      waterReducingAdditive: waterReducingAdditive?.value || '',
      waterReducingAdditivePercentage: waterReducingAdditivePercentage,
      otherAdditives: otherAdditives,
      otherAdditivesPercentage: otherAdditivesPercentage,
      concreteVolume: concreteVolume,
      cementId: cement?.value || '',
      waterId: water?.value || '',
      gravelsAndPercentages: gravelsAndPercentages.map((item) => ({
        gravelId: item.gravelToAdd.value,
        percentage: item.percentageFromGravelToAdd,
        humidity: item.humidityFromGravelToAdd
      })),
      sandsAndPercentages: sandsAndPercentages.map((item) => ({
        sandId: item.sandToAdd.value,
        percentage: item.percentageFromSandToAdd,
        humidity: item.humidityFromSandToAdd
      })),
      averageDiameter: averageDiameter,
      maxDiameter: maxDiameter,
      finenessModulus: finenessModulus,
      packagingValue: packagingToAdd,
      additiveConsumptionPercentage: additiveConsumptionPercentage,
      waterReducingAdditivesAndPercentages: waterReducingAdditivesAndPercentages.map((item) => ({
        additiveId: item.additiveToAdd.value,
        percentage: item.percentageFromAdditiveToAdd
      })),
      otherAdditivesAndPercentages: otherAdditivesAndPercentages.map((item) => ({
        additiveId: item.additiveToAdd.value,
        percentage: item.percentageFromAdditiveToAdd
      })),
      dosageStudyIdOne: dosageStudyOne?.value || '',
      dosageStudyIdTwo: dosageStudyTwo?.value || ''
    };

    api
      .post('/concrete-dosage/simulate-receipt', input, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setReceiptFromConcrete(returnFromApi.data);
        setGravelsQuantitiesPerCubicMeter(returnFromApi.data.gravelsQuantitiesPerCubicMeter);
        setSandsQuantitiesPerCubicMeter(returnFromApi.data.sandsQuantitiesPerCubicMeter);
        setShowReceiptConcreteModal(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error.response.data);
        setShowErrorMessage(true);
        setErrorMessage(error.response.data);
        setLoading(false);
      });
  };

  function openModalToViewConcreteDosage(concreteDosage) {
    setLoading(true);
    api
      .get('/concrete-dosage/view/' + concreteDosage.concreteDosageId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setRegisteredConcreteDosage(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });

    setShowRegisteredConcreteDosageModal(true);
  }

  function deleteConcreteDosage(concreteDosage) {
    setLoading(true);
    api
      .delete('/concrete-dosage/' + concreteDosage.concreteDosageId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setSuccessMessage(returnFromApi.data);
        setShowSuccessMessage(true);
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(returnFromApi.data);
        setShowErrorMessage(true);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function closeRegisteredConcreteDosageModal() {
    setShowRegisteredConcreteDosageModal(false);
  }

  function returnToConcreteDosageList() {
    navigate('/concrete-dosage/list');
  }

  return (
    <Card className="bg-transparent-50 overflow-hidden">
      <Authenticator />
      <Card.Header className="position-relative">
        <div className="row flex-between-center">
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

          <div className="col col-lg-8">
            <h5 className="mb-0 texto-negrito">Dosagem De Concreto</h5>
          </div>
        </div>

        {concreteDosageErrors && concreteDosageErrors.length > 0 && (
          <div className="mt-3">
            <Alert variant="danger">
              <Alert.Heading>Erros encontrados:</Alert.Heading>
              <ul className="mb-0">
                {concreteDosageErrors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </Alert>
          </div>
        )}
        <Loading isToHidden={isLoading == false} />
      </Card.Header>
      <Card.Body>
        <Form
          onSubmit={saveConcreteDosage}
          className={`form-container ${showReceiptConcreteModal || isLoading ? 'loading' : 'mt-3'}`}
        >
          {/* Estudo de dosagem Section */}
          <div className="mb-4">
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Nome da dosagem</Form.Label>
                  <Form.Control type="text" value={name} onChange={(e) => setName(e.target.value)} />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Código</Form.Label>
                  <Form.Control type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Parâmetros do concreto Section */}
          <div className="mb-4">
            <h4 className="mb-3 text-dark fw-bold">Parâmetros do concreto</h4>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Teor de argamassa (%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={mortarPercentage}
                    onChange={(e) => setMortarPercentage(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Ar incorporado (%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={incorporatedAir}
                    onChange={(e) => setIncorporatedAir(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Resistência (MPa)</Form.Label>
                  <Form.Control
                    type="text"
                    value={resistance}
                    onChange={(e) => setResistance(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Desvio padrão de resistência (MPa)</Form.Label>
                  <Form.Control
                    type="text"
                    value={resistanceStandardDeviation}
                    onChange={(e) => setResistanceStandardDeviation(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Slump (mm)</Form.Label>
                  <Form.Control
                    type="text"
                    value={slump}
                    onChange={(e) => setSlump(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Cimento</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToCements}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={cement}
                    onChange={(value) => setCement(value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Água</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToWaters}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={water}
                    onChange={(value) => setWater(value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Aditivos Section */}
          <div className="mb-4">
            <h4 className="mb-3 text-dark fw-bold">Aditivos</h4>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Aditivo redutor de água</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToWaterReducingAdditives}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={waterReducingAdditive}
                    onChange={(value) => setWaterReducingAdditive(value)}
                  />
                </Form.Group>
              </Col>

              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Porcentagem de Aditivo</Form.Label>
                  <Form.Control
                    type="text"
                    value={additiveConsumptionPercentage}
                    onChange={(e) => setAdditiveConsumptionPercentage(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Aditivo redutor de água</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToWaterReducingAdditives}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={waterReducingAdditiveToAdd}
                    onChange={(value) => setWaterReducingAdditiveToAdd(value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Porcentagem</Form.Label>
                  <Form.Control
                    type="text"
                    value={waterReducingAdditivePercentageToAdd}
                    onChange={(e) => setWaterReducingAdditivePercentageToAdd(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={2}>
                <Button className="mt-4" variant="primary" onClick={() => addWaterReducingAdditive()}>
                  Adicionar
                </Button>
              </Col>
            </Row> */}
            {/* <Row>
              <Col xs={12}>
                <Table responsive hidden={waterReducingAdditivesAndPercentagesToAdd.length === 0}>
                  <thead>
                    <tr>
                      <th scope="col">Aditivo Redutor de Água</th>
                      <th scope="col">Porcentagem</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {waterReducingAdditivesAndPercentagesToAdd.map((additive, index) => {
                      return (
                        <tr key={index}>
                          <td>{additive.additiveToAdd.label}</td>
                          <td>{additive.percentageFromAdditiveToAdd}%</td>
                          <td className="text-end">
                            <Dropdown className="d-inline-block ms-2">
                              <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  as={Link}
                                  onClick={() => deleteWaterReducingAdditiveFromList(additive)}
                                  className="text-danger"
                                >
                                  Excluir
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row> */}
            {/* <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Outros aditivos</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToAdditives}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={otherAdditivesToAdd}
                    onChange={(value) => setOtherAdditivesToAdd(value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Porcentagem</Form.Label>
                  <Form.Control
                    type="text"
                    value={otherAdditivesPercentageToAdd}
                    onChange={(e) => setOtherAdditivesPercentageToAdd(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={2}>
                <Button className="mt-4" variant="primary" onClick={() => addOtherAdditive()}>
                  Adicionar
                </Button>
              </Col>
            </Row> */}
            <Row>
              <Col xs={12}>
                <Table responsive hidden={otherAdditivesAndPercentages.length === 0}>
                  <thead>
                    <tr>
                      <th scope="col">Outros Aditivos</th>
                      <th scope="col">Porcentagem</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {otherAdditivesAndPercentages.map((additive, index) => {
                      return (
                        <tr key={index}>
                          <td>{additive.additiveToAdd.label}</td>
                          <td>{additive.percentageFromAdditiveToAdd}%</td>
                          <td className="text-end">
                            <Dropdown className="d-inline-block ms-2">
                              <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  as={Link}
                                  onClick={() => deleteOtherAdditiveFromList(additive)}
                                  className="text-danger"
                                >
                                  Excluir
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>

          {/* Estudos de Dosagem Reference Section */}
          <div className="mb-4">
            <h4 className="mb-3 text-dark fw-bold">Estudos de Dosagem</h4>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Estudo 1</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToDosageStudies}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={dosageStudyOne}
                    onChange={(value) => setDosageStudyOne(value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Estudo 2</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToDosageStudies}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={dosageStudyTwo}
                    onChange={(value) => setDosageStudyTwo(value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Britas e porcentagens de uso Section */}
          <div className="mb-4">
            <h4 className="mb-3 text-dark fw-bold">Britas e porcentagens de uso</h4>
            <Row>
              <Col xs={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Brita</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToGravels}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={selectedGravel}
                    onChange={(value) => setSelectedGravel(value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Porcentagem</Form.Label>
                  <Form.Control
                    type="text"
                    value={percentageFromGravel}
                    onChange={(e) => setPercentageFromGravel(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Umidade (%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={humidityFromGravel}
                    onChange={(e) => setHumidityFromGravel(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={2}>
                <Button className="mt-4" onClick={() => addGravel()}>
                  Adicionar
                </Button>
              </Col>
            </Row>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Diâmetro médio (mm)</Form.Label>
                  <Form.Control
                    disabled={true}
                    type="text"
                    value={averageDiameter}
                    onChange={(e) => setAverageDiameter(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Diâmetro máximo (mm)</Form.Label>
                  <Form.Control
                    disabled={true}
                    type="text"
                    value={maxDiameter}
                    onChange={(e) => setMaxDiameter(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Table responsive hidden={gravelsAndPercentages.length === 0}>
                  <thead>
                    <tr>
                      <th scope="col">Brita</th>
                      <th scope="col">Porcentagem</th>
                      <th scope="col">Umidade (%)</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {gravelsAndPercentages.map((gravel) => {
                      return (
                        <tr key={gravel.gravelToAdd.value}>
                          <td>{gravel.gravelToAdd.label}</td>
                          <td>{gravel.percentageFromGravelToAdd}%</td>
                          <td>{gravel.humidityFromGravelToAdd}%</td>
                          <td className="text-end">
                            <Dropdown className="d-inline-block ms-2">
                              <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  as={Link}
                                  onClick={() => deleteGravelFromList(gravel)}
                                  className="text-danger"
                                >
                                  Excluir
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>

          {/* Areias e porcentagens de uso Section */}
          <div className="mb-4">
            <h4 className="mb-3 text-dark fw-bold">Areias e porcentagens de uso</h4>
            <Row>
              <Col xs={4}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Areia</Form.Label>
                  <Select
                    closeMenuOnSelect={false}
                    options={comboBoxOptionsToSands}
                    placeholder="Selecione..."
                    classNamePrefix="react-select"
                    value={selectedSand}
                    onChange={(value) => setSelectedSand(value)}
                  />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Porcentagem</Form.Label>
                  <Form.Control
                    type="text"
                    value={percentageFromSand}
                    onChange={(e) => setPercentageFromSand(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Umidade (%)</Form.Label>
                  <Form.Control
                    type="text"
                    value={humidityFromSand}
                    onChange={(e) => setHumidityFromSand(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
              <Col xs={2}>
                <Button className="mt-4" onClick={() => addSand()}>
                  Adicionar
                </Button>
              </Col>
            </Row>
            <Row>
              {packagingErrorMessage && (
                <div className="alert alert-danger d-flex align-items-center mt-2" role="alert">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  <div>{packagingErrorMessage}</div>
                </div>
              )}
            </Row>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Módulo de Finura</Form.Label>
                  <Form.Control
                    disabled={true}
                    type="text"
                    value={finenessModulus}
                    onChange={(e) => setFinenessModulus(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Table responsive hidden={sandsAndPercentages.length === 0}>
                  <thead>
                    <tr>
                      <th scope="col">Areia</th>
                      <th scope="col">Porcentagem</th>
                      <th scope="col">Umidade (%)</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {sandsAndPercentages.map((sand) => {
                      return (
                        <tr key={sand.sandToAdd.value}>
                          <td>{sand.sandToAdd.label}</td>
                          <td>{sand.percentageFromSandToAdd}%</td>
                          <td>{sand.humidityFromSandToAdd}%</td>
                          <td className="text-end">
                            <Dropdown className="d-inline-block ms-2">
                              <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  as={Link}
                                  onClick={() => deleteSandFromList(sand)}
                                  className="text-danger"
                                >
                                  Excluir
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>

          {/* Volume de Concreto Section */}
          <div className="mb-4">
            <h4 className="mb-3 text-dark fw-bold">Volume de Concreto</h4>
            <Row>
              <Col xs={6}>
                <Form.Group className="mb-3" controlId="titleInput">
                  <Form.Label className="fs-9">Volume de Concreto (m³)</Form.Label>
                  <Form.Control
                    type="text"
                    value={concreteVolume}
                    onChange={(e) => setConcreteVolume(sanitizeNumericInput(e.target.value))}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <Button variant="falcon-primary" className="me-3" onClick={() => returnToConcreteDosageList()}>
              Voltar
            </Button>
            <Button type="submit">Salvar</Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
